import React, { useContext, useEffect, useState } from "react";
import { ITableColumn, Icon } from "../../components";
import { toast } from "react-toastify";
import './CustomerLoss.scss';
import CustomerLossService from "./CustomerLossService";
import Logger from "../../shared/services/Logger";
import DataTable from "../../components/components/Table/DataTable";
import { CustomerLossHistoryConstant, CUSTOMER_NOT_FOUND } from "../../shared/util/constant";
import CustomerLossForm from "./customer-loss-form/CustomerLossForm";
import { CustomerLossReadDto } from "../model/CustomerLossDto";
import { useConfirmationModalContext } from "../../shared/components/ModalConfirmationContext";
import CustomerLossFormService from "./customer-loss-form/CustomerLossFormservice";
import { AbilityContext } from "../../shared/abilities/AbilityContext";
import * as constant from '../../shared/util/constant';
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { RootState } from "../../shared/store";
import AppContext from "../../shared/components/AppContext";
import { CommonUtility } from "../../Services/CommonUtility";
import useSlider from "../../shared/components/Slider/useSlider";

export interface ICustomerLoss {
    customerId?: string
};

export interface LossPageState {
    isAddingNewLoss: boolean;
    isEditingLoss: boolean;
    editingNoteId?: string;
}

const initialPageState: LossPageState = {
    isAddingNewLoss: false,
    isEditingLoss: false,
    editingNoteId: null
};


const CustomerLoss: React.FunctionComponent<ICustomerLoss> = (props) => {
    const customerLossService = new CustomerLossService();
    const customerLossFormService = new CustomerLossFormService();
    const { customerId } = props;
    const [customerLosses, setCustomerLosses] = useState<CustomerLossReadDto[]>([]);
    const [lossFormState, setLossFormState] = useState<LossPageState>(initialPageState);
    const customerpolicyDetail = useSelector((state: RootState) => state?.customerSlice)
    const [currentCustomerLossData, setCurrentCustomerLossData] = useState<CustomerLossReadDto>({});
    const [expandedRowId, setExpandedRowId] = useState<string | null>(null);
    const [isFormSaved, setIsFormSaved] = useState(true);
    const myContext = useContext(AppContext);
    const sliderContext = useSlider();

    const modalContext = useConfirmationModalContext();

    const ability = useContext(AbilityContext);
    const canUserCreateCustomerLossHistory = ability.can('create', "Customer Loss History", constant.ScreenName.CUSTOMER_LOSS_HISTORY);
    const canUserEditCustomerLossHistory = ability.can('update', "Customer Loss History", constant.ScreenName.CUSTOMER_LOSS_HISTORY);
    const canUserDeleteCustomerLossHistory = ability.can('delete', "Customer Loss History", constant.ScreenName.CUSTOMER_LOSS_HISTORY);

    const newLoss: CustomerLossReadDto = {}

    useEffect(() => {
        initializeComponent();
    }, []);

    useEffect(() => {
        
        if (lossFormState.isAddingNewLoss || lossFormState.isEditingLoss) {
            myContext.formSavedStatus = false;
        }
    }, [lossFormState.isAddingNewLoss, lossFormState.isEditingLoss]);

    useEffect(() => {
        if (sliderContext.isSliderVisible) {
            document.body.classList.remove('loss-no-page-scroll');
            return;
        }

        document.body.classList.add('loss-no-page-scroll');
        return () => {
            document.body.classList.remove('loss-no-page-scroll');
        };
    }, [sliderContext.isSliderVisible]);

    const initializeComponent = async () => {
        try {
            await fetchLossHistoryData();
        }
        catch (ex) {
            toast.error(CustomerLossHistoryConstant.ERROR_OCCURED_WHILE_INIT_COMPONENT, {
                position: toast.POSITION.TOP_RIGHT
            });
            Logger.logError(CustomerLossHistoryConstant.ERROR_OCCURED_WHILE_INIT_COMPONENT, ex);
        }
    };

    const fetchLossHistoryData = async () => {
        try {
            let lossData = await customerLossService.fetchCustomerLosess(customerId);
            PolicyNumberToDisplay(lossData); // Need to remove this code once policyId implementation completes
            setCustomerLosses(lossData);
        }
        catch (ex) {
            toast.error(CustomerLossHistoryConstant.ERROR_OCCURED_WHILE_FETCHING_LOSS_HISTORY, {
                position: toast.POSITION.TOP_RIGHT
            });
            Logger.logError(CustomerLossHistoryConstant.ERROR_OCCURED_WHILE_FETCHING_LOSS_HISTORY, ex);
        }
    }

    const PolicyNumberToDisplay = (data: any[]) => {
        data.forEach((item) => {
            item.policyNumberToDisplay = CommonUtility.formatPolicy(
                item.policyNumber,
                item.policyEffDate,
                item.policyExpDate
            )
        });
    }

    const onAddNewLossClick = (e) => {
        if (lossFormState.isAddingNewLoss || lossFormState.isEditingLoss) {
            return;
        }

        const newLoss: CustomerLossReadDto = {
            id: '',// Assign unique ID
            custId: customerId,
            company: '',
            lossDescription: '',
            policyNumber: '',
            lossType: '',
            policyEffDate: null,
            policyExpDate: null,
            claimId: '',
            claimNo: '',
            dateOfLoss: null,
            reportDate: null,
            amountPaid: null,
            claimStatusId: '',
            closedDate: null,
            changedBy: '',
            changedDate: null,
            enteredDate: null,
            changedByValue: '',
            displayName: '',
            lossTypeValue: '',
            claimStatusValue: ''
        };

        setCustomerLosses([newLoss, ...customerLosses]);
        setCurrentCustomerLossData(newLoss);
        setLossFormState({ ...lossFormState, isAddingNewLoss: true });
        setExpandedRowId(newLoss.id); // Set the expanded row to the new row's ID
    };

    let AddNewLossButton = <></>;

    if (!lossFormState.isAddingNewLoss && !lossFormState.isEditingLoss && customerpolicyDetail.policies.length > 0) {
        AddNewLossButton = <>
            <Button
                variant="primary"
                className="mb-2 ml-n5"
                key="filter"
                onClick={(e) => onAddNewLossClick(e)}
                tabIndex={21}
                id="btnLosssAdd"
                disabled={!canUserCreateCustomerLossHistory}
                autoFocus
            >
                <i className="bi bi-plus-circle me-2"></i>
                {CustomerLossHistoryConstant.ADD_LOSS}
            </Button>
        </>;
    }


    const onLossFormCancelClick = () => {
        if (lossFormState.isAddingNewLoss) {
            const updatedCustomerLosses = customerLosses.filter(loss => loss.id !== '');
            setCustomerLosses(updatedCustomerLosses);
        }
        setLossFormState({ ...lossFormState, isAddingNewLoss: false, isEditingLoss: false });
        setExpandedRowId(null);
        setIsFormSaved(true)
    };

    const onLoassHistoryCreated = (lossDto: CustomerLossReadDto) => {
        resetPage();
    }

    const onLoassHistoryUpdated = (lossDto: CustomerLossReadDto) => {
        resetPage();
    }

    const resetPage = () => {
        setCurrentCustomerLossData({});
        setLossFormState({ ...lossFormState, isEditingLoss: false, isAddingNewLoss: false });
        fetchLossHistoryData();
        setExpandedRowId(null);
        setIsFormSaved(true);
    }
    const handleFormChange = async (isSaved) => {
        myContext.formSavedStatus = true
        setIsFormSaved(isSaved);
    }

    const customerLossFormView = <CustomerLossForm
        customerLoss={currentCustomerLossData}
        customerId={customerId}
        onCancelClick={onLossFormCancelClick}
        onLossHistoryCreated={onLoassHistoryCreated}
        onLossHistoryUpdated={onLoassHistoryUpdated}
        setIsFormSaved={handleFormChange}></CustomerLossForm>

    const onRowEditClick = (rowData: any, column: ITableColumn) => {

        if (lossFormState.isAddingNewLoss || lossFormState.isEditingLoss) {
            return;
        }

        rowData.policyNumber = rowData.policyNumberToDisplay; // Need to remove this code once policyId implementation completes
        
        setCurrentCustomerLossData(rowData);
        setLossFormState({ ...lossFormState, isEditingLoss: true });
    }

    const onRowDeleteClick = async (rowData: any, column: ITableColumn) => {
        try {

            if (lossFormState.isAddingNewLoss || !lossFormState.isEditingLoss) {
                return;
            }

            const result = await modalContext.showConfirmation(CustomerLossHistoryConstant.LOSS_HISTORY_DELETE_CONFIRMATION)
            if (!result) {
                return;
            }

            await customerLossFormService.removeCustomerLossData(rowData);
            resetPage();
        }
        catch (ex) {
            if (ex.status == 404) {
                toast.error(CUSTOMER_NOT_FOUND, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
            else {
                toast.error(CustomerLossHistoryConstant.DELETE_CUSTOMER_LOSS_ERROR_MESSAGE, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        }
    }

    const renderRow = (loss, index) => {
        return (
            <React.Fragment key={loss.id || index}>

                {(lossFormState.isEditingLoss || lossFormState.isAddingNewLoss) && currentCustomerLossData.id === loss.id && (
                    <tr>
                        <td colSpan={tableColumns.length}>
                            <div className="customer-loss-form-wrapper">
                                {customerLossFormView}
                            </div>
                        </td>
                    </tr>
                )}
            </React.Fragment>
        );
    };


    const tableColumns: ITableColumn[] = customerLossService.getLossHistoryTableColumns(onRowEditClick, onRowDeleteClick, onLossFormCancelClick);
    return (
        <div className="loss-inner-scroll">
            <div className="cst-dv-loss-main">
                <div className="cst-dv-actions">
                    {AddNewLossButton}
                </div>

                <DataTable
                    columns={tableColumns}
                    data={customerLosses}
                    keyColumnName="id"
                    expandedRowId={expandedRowId}
                    setExpandedRowId={setExpandedRowId}
                    renderRow={renderRow}
                    isFormSaved={isFormSaved}
                    isDeleteDisabled={(expandedRowId == null) ? true : !canUserDeleteCustomerLossHistory}
                    isEditDisabled={!canUserEditCustomerLossHistory}
                />
            </div>
        </div>
    );
};

export default CustomerLoss;